import { mapActions } from 'vuex';

export default {
  name: 'ServiceCategoryTitle',

  props: {
    title: {
      type: String,
      default: (() => 'Usługi')
    },
    show_return: {
      type: Boolean,
      default: (() => false)
    },
    subtitle: {
      type: String,
      default: (() => '')
    },
  },

  data() {
    return {
      arrow: require("@/assets/arrow-up.svg"),
    };
  },

  computed: {},

  methods: {
    ...mapActions(['selectCategory', 'getServicesList']),
    handleClick() {
      this.getServicesList();
      this.selectCategory(null);
    }
  },
}


// WEBPACK FOOTER //
// ./src/components/Services/ServiceCategoryTitle/component.js